import React, { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { Lock, User } from "lucide-react";

interface LoginFormProps {
  onLogin: (loginOrEmail: string, password: string) => void;
  isLoading?: boolean;
  error?: string;
}

export const LoginForm: React.FC<LoginFormProps> = ({
  onLogin,
  isLoading,
  error,
}) => {
  const [loginOrEmail, setLoginOrEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (loginOrEmail.trim() && password.trim()) {
      onLogin(loginOrEmail, password);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background transition-colors">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1 text-center">
          <div className="flex justify-center mb-4">
            <img
              src="/logo.png"
              alt="SZKŁO Sp. z o.o."
              className="h-16 w-auto transition-opacity duration-300 dark:opacity-90"
            />
          </div>
          <CardTitle className="text-2xl font-bold">
            Panel Administracyjny
          </CardTitle>
          <CardDescription>Zaloguj się do systemu WorkFlow</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="loginOrEmail">Login / Email <span className="text-red-500">*</span></Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-4 h-4" />
                <Input
                  id="loginOrEmail"
                  type="text"
                  placeholder="admin lub admin@workflow.pl"
                  value={loginOrEmail}
                  onChange={(e) => setLoginOrEmail(e.target.value)}
                  className="pl-10"
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Hasło <span className="text-red-500">*</span></Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-4 h-4" />
                <Input
                  id="password"
                  type="password"
                  placeholder="Wprowadź hasło"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="pl-10"
                  disabled={isLoading}
                />
              </div>
            </div>

            {error && (
              <div className="text-red-500 text-sm bg-red-50 dark:bg-red-900/20 dark:text-red-400 p-3 rounded-md transition-colors">
                {error}
              </div>
            )}

            <Button
              type="submit"
              className="w-full"
              disabled={!loginOrEmail.trim() || !password.trim() || isLoading}
            >
              {isLoading ? "Logowanie..." : "Zaloguj się"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
